/* 
 * Custom Tests using Modernizr's addTest API
 */

/* Browser Touch
 * This is a replica of the logic in Modernizr 3.5 before the touchevents test broke for Chrome (current version 72)
 */
Modernizr.addTest('browsertouch', function () {
    return ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;
});